import React from "react";
import ErrorField from "./error";
import { TextField } from "components/support";
import { observer } from "mobx-react";

const CsosnField = ({ errors, row, onChange }) => {
  const { taxes } = row;
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors &&
    !!foundErrors.errors &&
    !!foundErrors.errors.taxes &&
    !!foundErrors.errors.taxes.csosn;

  return (
    <div>
      <TextField
        value={taxes.csosn}
        onChange={(_, value) => onChange(value.replace(/\D/g, ""))}
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.taxes.csosn} />}
    </div>
  );
};

export default observer(CsosnField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/csosn.js